<style>
.table-fixed-actions table > thead > tr > th:nth-last-child(1),
.table-fixed-actions table > tbody > tr:not(.v-data-table__empty-wrapper) > td:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  background-color: white;
  border-left: thin solid rgba(0, 0, 0, 0.12);
}
</style>

<template>
  <v-data-table
    :class="computedClass"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'AnchorDataTable',
  computed: {
    computedClass: vm => {
      const { classes, headers } = vm.$attrs;
      const fixedActionsClass = headers.length && headers[headers.length - 1].value === 'actions' ?
        'table-fixed-actions' :
        '';
      return `${classes || ''} ${fixedActionsClass}`.trim();
    },
  },
};
</script>
